import React from 'react';
import { COLORS } from "Constants/BIDashboardConstants"

const ZoomInIcon = () => {
  return (
    <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Image-Button-Row" transform="translate(-463.000000, -13.000000)" fill={COLORS.oneGp.globalBlue} fillRule="nonzero">
          <g id="Image-Nav" transform="translate(350.000000, 0.000000)">
            <path d="M127.6875,19.5625 L121.4375,19.5625 L121.4375,13.3125 C121.4375,13.1398438 121.297656,13 121.125,13 L119.875,13 C119.702344,13 119.5625,13.1398438 119.5625,13.3125 L119.5625,19.5625 L113.3125,19.5625 C113.139844,19.5625 113,19.7023438 113,19.875 L113,21.125 C113,21.2976563 113.139844,21.4375 113.3125,21.4375 L119.5625,21.4375 L119.5625,27.6875 C119.5625,27.8601563 119.702344,28 119.875,28 L121.125,28 C121.297656,28 121.4375,27.8601563 121.4375,27.6875 L121.4375,21.4375 L127.6875,21.4375 C127.860156,21.4375 128,21.2976563 128,21.125 L128,19.875 C128,19.7023438 127.860156,19.5625 127.6875,19.5625 Z" id="Path" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ZoomInIcon;
